import React, { useState } from 'react';
import { Box, TextField, Button, DialogActions, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGetAiSuggestionsMutation } from '../api/aiApi'; // Adjust import based on your project structure

interface AboutFormProps {
  about: any;
  onCancel: () => void;
  onUpdate: (updatedAbout: string) => void;
}

const AboutForm: React.FC<AboutFormProps> = ({ about, onCancel, onUpdate }) => {
  const { t } = useTranslation();
  const [aboutText, setAboutText] = useState<any>(about);
  const [suggestion, setSuggestion] = useState<string | null>(null);
  const [getAiSuggestions, { isLoading, error }] = useGetAiSuggestionsMutation();
console.log('errrror', error)
  const handleSuggestClick = async () => {
    try {
      const response = await getAiSuggestions(aboutText.about);
      if (response?.data) {
        setSuggestion(response.data.suggestion.trim());
      }
    } catch (error) {
      console.error("Error fetching AI suggestion:", error);
      // Display an appropriate error message for the user
      alert("There was an error fetching the AI suggestion. Please try again later.");
    }
  };

  const handleAcceptSuggestion = () => {
    setAboutText({ ...aboutText, about: suggestion });
    setSuggestion(null); // Clear suggestion after accepting
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onUpdate(aboutText.about); // Pass only the text
  };

  return (
    <Container maxWidth="sm" sx={{ width: '90vw' }}>
      <Box
        sx={{
          mt: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ mt: 1, width: '100%' }}
        >
          <TextField
            size="small"
            label="About"
            margin="normal"
            type="text"
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            fullWidth
            multiline
            rows={6}
            value={aboutText.about}
            onChange={(e) => setAboutText({ ...aboutText, about: e.target.value })}
          />
          {suggestion && (
            <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
              <Typography variant="body2" color="textSecondary">
                {t('AI Suggestion')}
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                {suggestion}
              </Typography>
              <Button
                onClick={handleAcceptSuggestion}
                color="primary"
                sx={{ mt: 1 }}
              >
                {t('Accept Suggestion')}
              </Button>
            </Box>
          )}
          {error && (
            <Typography color="error" sx={{ mt: 2 }}>
              There was an error fetching the suggestion. Please try again later.
            </Typography>
          )}
          <DialogActions>
            <Button onClick={onCancel} color="secondary">
              {t('Cancel')}
            </Button>
            <Button
              onClick={handleSuggestClick}
              color="primary"
              disabled={isLoading} // Disable button while loading suggestion
            >
              {isLoading ? t('Generating...') : t('Get Suggestion')}
            </Button>
            <Button type="submit" color="primary">
              {t('Update')}
            </Button>
          </DialogActions>
        </Box>
      </Box>
    </Container>
  );
};

export default AboutForm;
